export const NEW_PIXEL_POSITIONS_BY_FRAME = [
    [],
    [[0, 0]],
    [
        [0, 4],
        [4, 0],
        [4, 4],
        [6, 6],
    ],
    [
        [2, 2],
        [2, 6],
        [6, 2],
    ],
    [
        [0, 2],
        [0, 6],
        [4, 2],
        [4, 6],
    ],
    [
        [2, 4],
        [6, 0],
        [6, 4],
    ],
    [
        [2, 0],
        [3, 3],
        [7, 7],
    ],
    [
        [1, 1],
        [3, 7],
        [5, 1],
        [5, 5],
        [7, 3],
    ],
    [
        [1, 5],
        [3, 1],
        [7, 5],
    ],
    [
        [1, 3],
        [3, 5],
        [5, 7],
        [7, 1],
    ],
    [
        [0, 7],
        [1, 7],
        [4, 3],
        [5, 3],
    ],
    [
        [0, 3],
        [4, 7],
        [6, 5],
    ],
    [
        [0, 5],
        [2, 1],
        [2, 5],
        [4, 1],
        [6, 1],
    ],
    [
        [0, 1],
        [4, 5],
        [6, 7],
    ],
    [
        [2, 3],
        [2, 7],
        [3, 4],
        [6, 3],
        [7, 0],
        [7, 4],
    ],
    [
        [1, 2],
        [3, 0],
        [5, 2],
        [5, 6],
    ],
    [
        [1, 6],
        [3, 2],
        [3, 6],
        [5, 0],
        [7, 2],
        [7, 6],
    ],
    [
        [1, 0],
        [1, 4],
        [5, 4],
    ],
];

export const NUMBER_OF_FRAMES = NEW_PIXEL_POSITIONS_BY_FRAME.length;

export const DELAY_MS = 15;

export enum BackgroundMode {
    Dark = 'dark',
    Light = 'light',
}
